import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Loader2, ArrowRight } from "lucide-react";
import client from "@/lib/api";
import AppShell from "@/components/AppShell";
import { useLang } from "@/context/LangContext";

export default function ChooseLanguage() {
  const nav = useNavigate();
  const { t } = useLang();
  const [langs, setLangs] = useState([]);
  const [sel, setSel] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    client.get("/learn/languages").then(({ data }) => {
      setLangs(data);
      const first = data.find((l) => l.has_content) || data[0];
      setSel(first?.code);
    }).catch(() => {});
  }, []);

  const cont = async () => {
    if (!sel) return;
    setBusy(true);
    try {
      await client.post("/learn/select-language", { code: sel });
      nav("/home");
    } finally { setBusy(false); }
  };

  return (
    <AppShell nav={false}>
      <div className="pt-12 pb-8">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight text-[#0F172A]">{t("cl_title")}</h1>
        <p className="text-slate-500 mt-2">{t("cl_sub")}</p>
        <div className="mt-8 space-y-3" data-testid="language-selector">
          {langs.map((l) => (
            <button key={l.code} data-testid={`lang-option-${l.code}`} onClick={() => setSel(l.code)}
              className={`w-full flex items-center gap-4 rounded-2xl px-5 py-4 border transition-all ${sel === l.code ? "border-[#2563EB] bg-[#2563EB]/5 shadow-[0_8px_24px_-12px_rgba(30,86,160,0.5)]" : "border-slate-200 bg-white"}`}>
              <span className="text-3xl">{l.flag}</span>
              <span className="flex-1 text-left">
                <span className="block font-bold text-[#0F172A]">{t(`lang_${l.code}`)}</span>
                <span className="block text-sm text-slate-400">{l.native_name}{!l.has_content && ` · ${t("common_coming_soon")}`}</span>
              </span>
              {sel === l.code && <Check className="text-[#2563EB]" />}
            </button>
          ))}
        </div>
      </div>
      <div className="sticky bottom-0 pb-6 pt-2 bg-gradient-to-t from-[#F6F9FD] to-transparent">
        <button onClick={cont} disabled={busy || !sel} data-testid="choose-lang-continue"
          className="w-full bg-[#2563EB] text-white font-bold py-4 rounded-2xl flex items-center justify-center gap-2 disabled:opacity-60 shadow-[0_14px_34px_-14px_rgba(30,86,160,0.9)]">
          {busy ? <Loader2 className="animate-spin" size={18} /> : <>{t("common_continue")} <ArrowRight size={18} /></>}
        </button>
      </div>
    </AppShell>
  );
}
